import * as Yup from "yup";

export const FormikObj = {
    initialValues: {
    initialValues: {
        id: "",
        orgId: "",
        name: "",
        type: "",
        fileType: "PDF",
        protocol: "",
        hostName: "",
        userName: "",
        secret: "",
        target: "",
        messageSpec: "",
    },
    },
    validationSchema: Yup.object({
        orgId: Yup.string().required("Required Organization"),
        name: Yup.string().required("Required Report Delivery Name"),
        type : Yup.string().required("Required Delivery Type"),
        protocol: Yup.string().when('type', {
            is: "MFT",
            then: Yup.string().required("Protocol is Required"),
            otherwise: Yup.string().notRequired()
        }),
        hostName: Yup.string().when('type', {
            is: "MFT",
            then: Yup.string().required("Hostname is Required"),
            otherwise: Yup.string().notRequired()
        }),
        fileType: Yup.string().required("Required Filetype"),
        target: Yup.string().required("Required Delivery Target") 
    }),
}

export const FormikObjEdit = {
    initialValues: {
        id: "",
        orgId: "",
        name: "",
        type: "",
        fileType: "",
        protocol: "",
        hostName: "",
        userName: "",
        secret: "",
        target: "",
        messageSpec: "",
    },
    validationSchema: Yup.object({
        orgId: Yup.string().required("Required Organization"),
        name: Yup.string().required("Required Report Delivery Name"),
        type : Yup.string().required("Required Delivery Type"),
        protocol: Yup.string().when('type', {
            is: "MFT",
            then: Yup.string().required("Protocol is Required"),
            otherwise: Yup.string().notRequired()
        }),
        hostName: Yup.string().when('type', {
            is: "MFT",
            then: Yup.string().required("Hostname is Required"),
            otherwise: Yup.string().notRequired()
        }),
        fileType: Yup.string().required("Required Filetype"),
        target: Yup.string().required("Required Delivery Target") 
    }),
}
export const fileTypes = [
    { value: "PDF", label: "PDF" },
]
export const deliveryTypes = [
    { value: "FAX", label: "Fax" },
    { value: "MFT", label: "MFT" },
]
export const protocols = [
    { value: 'SFTP', label: "SFTP"},
    { value: 'HTTPS', label: 'HTTPS'}
]
